import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
const pageData: Record<string, {
  title: string;
  body: string;
}> = {
  '1': {
    title: 'Privacy Statement',
    body: `By registering with Desert Sage Seminars, you will create an account by which we may provide you with quality on-line real estate license renewal classes. Your information will be kept confidential and not shared with any other party.\nThe Arizona Department of Real Estate requires that we confirm your information and that you are the person taking the classes.\nPayments you make for our classes are made through a 3rd party merchant account secured by our site, and they do not share your credit card information with us or any other party.\nAny requests by an outside party for information about you or your account will be denied except for any request from the Arizona Department of Real Estate, or any other regulatory agency empowered to investigate your real estate activity.\nAny questions or concerns about our Privacy Policy should be sent to support@desertsageseminars.com`
  },
  '2': {
    title: 'About Us',
    body: 'Learn about our history and mission.'
  },
  '3': {
    title: 'Terms of Service',
    body: 'Please read these terms carefully.'
  }
};
export function EditStaticPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const data = id ? pageData[id] : null;
  return <div className="space-y-4" data-id="element-884">
      <div className="flex items-center justify-between" data-id="element-885">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-886">Edit Static Page</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/static-pages')} data-id="element-887">
          ← Back to Static Pages
        </Button>
      </div>

      <Card data-id="element-888">
        <CardContent className="pt-6" data-id="element-889">
          <form className="space-y-5 max-w-2xl" data-id="element-890">
            <Input label="Title" defaultValue={data?.title ?? ''} data-id="element-891" />

            <div data-id="element-892">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-893">
                Body
              </label>
              <div className="border border-slate-300 rounded-md overflow-hidden" data-id="element-894">
                {/* Toolbar row 1 */}
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-895">
                  <button type="button" className="px-1.5 py-0.5 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-896">
                    Source
                  </button>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-897" />
                  {['📄', '📋', '✂', '🗑', '↩', '↪'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-898">
                      {ic}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-899" />
                  {['🔍', '🔤', '🖊'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-900">
                      {ic}
                    </button>)}
                </div>
                {/* Toolbar row 2 */}
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-901">
                  {['B', 'I', 'U', 'S'].map(t => <button key={t} type="button" className="w-6 h-6 text-xs font-bold border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-700" data-id="element-902">
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-903" />
                  {['≡', '≣', '❝', '»'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-904">
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-905" />
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-906">
                    <option data-id="element-907">Styles</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-908">
                    <option data-id="element-909">Format</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-910">
                    <option data-id="element-911">Font</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-912">
                    <option data-id="element-913">Size</option>
                  </select>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-914" />
                  {['A', 'A', '⊞', '⊟', '⊕', '?'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-915">
                      {t}
                    </button>)}
                </div>
                <textarea className="w-full p-3 text-sm focus:outline-none resize-y min-h-[200px] bg-white" defaultValue={data?.body ?? ''} data-id="element-916" />
              </div>
            </div>

            <div className="pt-2" data-id="element-917">
              <Button type="submit" data-id="element-918">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}